/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Provider row actions (kebab menu)
 */
import { Dropdown, Button, Tooltip } from 'antd';
import { MoreOne } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';

import EditProvider from './EditProvider';
import UpdateProviderStatus from './UpdateProviderStatus';
import { defaultDropdownButtonProps } from './ClaimTableActions';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

interface IProps {
	providerDetails: Provider.IResponseModel;
}

const ProviderActions: React.FC<IProps> = ({ providerDetails }) => {
	const { setupInfo, userAccess } = useAppStoreValues();
	const { canEditProviders, canUpdateProviderStatus } = userAccess;
	const isBillingCustomer = setupInfo?.isBillingCustomer;

	const schema: MenuItemType[] = [
		...(!isBillingCustomer
			? [
					{
						key: 'edit',
						className: 'tw-dropdown-menu-item',
						label: <EditProvider providerId={providerDetails.id} {...defaultDropdownButtonProps} />,
					} as MenuItemType,
				]
			: []),
		{
			key: 'status',
			className: 'tw-dropdown-menu-item',
			label: <UpdateProviderStatus providerDetails={providerDetails} {...defaultDropdownButtonProps} />,
		},
	];

	const isAnyActionEnabled = (!isBillingCustomer && canEditProviders) || canUpdateProviderStatus;

	return (
		<Dropdown menu={{ items: schema }} placement='bottomRight' trigger={['click']} disabled={!isAnyActionEnabled}>
			<Tooltip title={isAnyActionEnabled ? '' : NO_ACCESS_TOOLTIP_TEXT}>
				<Button color='default' icon={<MoreOne />} onClick={(e) => e.stopPropagation()} disabled={!isAnyActionEnabled} />
			</Tooltip>
		</Dropdown>
	);
};

export default ProviderActions;
